// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "3e3289f07b7e9a09","396": "2c34e40357b7013b","460": "a7b7d73f082c718f","917": "4b5d99c9c9b283fb","985": "4bb4eafa7a00a02b",}[chunkId] + ".chunk.js"
}